const MASS_EDIT_LIST_NAMES = [
    'staff_list',
    'activation_list',
    'category_list',
    'service_list',
    'tag_list',
    'product_list',
    'specialization_list',
    'filial_list',
] as const

export function getMassEditClipboardKey(valueField?: string, listKey?: string): string {
    const sources = [listKey, valueField].filter((value): value is string => Boolean(value))
    const matched = MASS_EDIT_LIST_NAMES.find((name) =>
        sources.some((source) => source === name || source.includes(name)),
    )
    return matched || listKey || valueField || ''
}

export function readMassEditClipboard(valueField?: string, listKey?: string): string | null {
    const primary = getMassEditClipboardKey(valueField, listKey)
    const keys = [`massEdit-${primary}`]
    if (valueField && `massEdit-${valueField}` !== keys[0]) {
        keys.push(`massEdit-${valueField}`)
    }
    for (const storageKey of keys) {
        const value = localStorage.getItem(storageKey)
        if (value) {
            return value
        }
    }
    return null
}
